import {ChallengeMetric} from 'src/app/core/model/project';
import {TrackerMetricTypes} from 'src/app/trackers/shared/tracker-metric-types';
import {formatDuration} from './duration.util';

/**
 * Formats a ChallengeMetric's target into a display string.
 * Example output: "4 times or more per day" or "140 grams or more per cycle"
 */
export function getTargetDisplayString(metric: ChallengeMetric): string {
  const target = metric.target;
  if (!target) return '';

  const value =
    metric.type === TrackerMetricTypes.Duration ? formatDuration(target.targetValue, true) : target.targetValue;
  const option = getOperatorDisplayValue(target.targetOperator);
  const period = target.targetPeriod === 'perDay' ? 'per day' : 'per cycle';

  return `${value} ${metric.type === TrackerMetricTypes.Duration ? '' : metric.typeOption} ${option} ${period}`;
}

function getOperatorDisplayValue(operator: string): string {
  switch (operator) {
    case 'eq':
      return '';
    case 'lte':
      return 'or less';
    default:
      return 'or more';
  }
}
